<template>
  <div :class="containerClasses" @mouseleave="onMouseLeave" class="donate-container">
    <div
      @click="onClick"
      @mouseenter="onMouseEnter"
      :class="{'donate-pin': clicked}"
      class="donate-button"
    >打赏</div>

    <div :class="{'donate-visible': popupVisible}" class="donate-popup">
      <div class="donate-amounts">
        <div
          class="donate-amount"
          :class="{'donate-amount-selected': selectedAmount === amount}"
          @click="selectedAmount = amount"
          v-for="amount in availableAmounts"
          :key="amount"
        >{{ amount }}元</div>
      </div>
      <img :src="selectedWechatpayImagePath" />
      <img :src="selectedAlipayImagePath" />
    </div>
  </div>
</template>

<script>
import Vue from "vue";

export default Vue.extend({
  props: {
    direction: {
      type: String,
      default: "bottom"
    },
    align: {
      type: String,
      default: "right"
    }
  },
  data: function() {
    return {
      popupVisible: false,
      clicked: false,
      selectedAmount: 10,
      availableAmounts: [5, 10, 20, 50, 100]
    };
  },
  computed: {
    containerClasses: function() {
      return ["donate-d-" + this.direction, "donate-a-" + this.align];
    },
    selectedWechatpayImagePath: function() {
      return this.getWechatpayImagePath(this.selectedAmount);
    },
    selectedAlipayImagePath: function() {
      return this.getAlipayImagePath(this.selectedAmount);
    }
  },
  methods: {
    getWechatpayImagePath: function(amount) {
      return require("../assets/donate/donate-wechatpay-" + amount + ".png");
    },
    getAlipayImagePath: function(amount) {
      return require("../assets/donate/donate-alipay-" + amount + ".png");
    },
    onClick: function() {
      if (this.popupVisible) {
        if (this.clicked) {
          this.clicked = false;
          this.popupVisible = false;
        } else {
          this.clicked = true;
        }
      } else {
        this.clicked = true;
        this.popupVisible = true;
      }
    },
    onMouseEnter: function() {
      this.popupVisible = true;
    },
    onMouseLeave: function() {
      if (!this.clicked) this.popupVisible = false;
    }
  }
});
</script>

<style>
.donate-container {
  display: inline-block;
  position: relative;
}

.donate-button {
  border: solid 1px #ccc;
  border-radius: 2px;
  background-color: #eee;
  padding: 3px 8px;
  cursor: pointer;
}

.donate-pin {
  border-color: rgb(106, 167, 207);
  background-color: rgb(173, 216, 233);
}

.donate-popup {
  display: none;
  outline: solid 1px #ccc;
}

.donate-popup img {
  max-width: 220px;
}

.donate-popup.donate-visible {
  display: block;
  position: absolute;
}

.donate-d-top .donate-popup {
  bottom: -100%;
}
.donate-d-right .donate-popup {
  left: 100%;
}
.donate-d-bottom .donate-popup {
  top: 100%;
}
.donate-d-left .donate-popup {
  right: 100%;
}

.donate-a-top .donate-popup {
  top: 1px;
}
.donate-a-right .donate-popup {
  right: 1px;
}
.donate-a-bottom .donate-popup {
  bottom: 1px;
}
.donate-a-left .donate-popup {
  left: 1px;
}

.donate-amounts {
  background: #eee;
  color: #666;
  display: flex;
  justify-content: space-around;
  line-height: 2;
}

.donate-amount {
  cursor: pointer;
}

.donate-amount-selected {
  font-weight: bold;
  color: black;
}
</style>
